// extracted by mini-css-extract-plugin
export default {"header":"lf4mrLol7UI4KTfsKoLD__header___"};